import { createSelector } from 'reselect';
import { persistFiltersOnCategorySelector } from 'selectors/testTarget/offers/persistFiltersOnCategory/persistFiltersOnCategorySelector';

const enabledSelector = createSelector(persistFiltersOnCategorySelector, persistFiltersOnCategory => !!persistFiltersOnCategory.enabled);

export { enabledSelector };
